import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Col, Row, Form, Button, Card,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import axios from 'axios';
import { Content } from '../styles';
import ModalKonfirmasi from '../../../../../components/ModalKonfirmasi';
import config from '../../../../../config';

const FormPengajuanKUM = (props) => {
  const formData = new FormData();
  const today = new Date();
  const [proposal, setProposal] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [state, setState] = useState({
    nama: '',
    npm: '',
    prodi: '',
    nama_organisasi: '',
    jabatan: '',
    email: '',
    no_telepon: '',
    nama_kegiatan: '',
    jenis_kegiatan: 'kuliah umum',
    tanggal: '',
    pukul: '',
    penyelenggara: '',
    biaya: 0,
    sertifikat: 'Ya (E-Sertifikat Gratis)',
    link_regis: 'https://',
    lokasi: '',
    pembicara: '',
    moderator: '',
    proposal: '',
    deskripsi: '',
    nama_po_kegiatan: '',
  });

  const [error, setError] = useState('');

  const SUPPORTED_FORMATS = ['application/pdf'];

  const FILESIZE = 10485760;

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}api/account/detail-info/`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then((info) => {
      setState({
        nama: info.data.user.name,
        npm: info.data.user.npmnip,
        prodi: info.data.prodi,
      });
    });
  }, []);

  const handleFileChange = (e) => {
    setProposal({
      files: e.target.files[0],
    });
  };

  const inputChange = (e, input) => {
    let ubah = e.target.value;
    if (input === 'link_regis') {
      if (ubah.length <= 8) {
        ubah = 'https://';
      } else if (!e.target.value.startsWith('https://')) {
        ubah = `https://${e.target.value}`;
      }
    }
    setState({
      ...state,
      [input]: ubah,
    });
  };

  const formik = useFormik({
    initialValues: {
      nama_organisasi: '',
      jabatan: '',
      email: '',
      no_telepon: '',
      nama_kegiatan: '',
      jenis_kegiatan: 'kuliah umum',
      tanggal: '',
      pukul: '',
      penyelenggara: '',
      biaya: 0,
      sertifikat: 'Ya (E-Sertifikat Gratis)',
      link_regis: 'https://',
      lokasi: '',
      pembicara: '',
      moderator: '',
      proposal: '',
      deskripsi: '',
      nama_po_kegiatan: '',
    },
    validationSchema: Yup.object({
      nama_organisasi: Yup.string().required('Nama organisasi harus diisi!'),
      jabatan: Yup.string().required('Jabatan harus diisi!'),
      email: Yup.string().email().required('Email harus diisi!'),
      no_telepon: Yup.string().required('Nomor Telepon harus diisi!'),
      nama_kegiatan: Yup.string().required('Nama Kegiatan harus diisi!'),
      jenis_kegiatan: Yup.string().required('Required!'),
      tanggal: Yup.date().min(today, 'Harus waktu di masa yang akan datang!'),
      penyelenggara: Yup.string().required('Penyelenggara harus diisi!'),
      sertifikat: Yup.string().required('Keterangan sertifikat harus diisi!'),
      lokasi: Yup.string().required('Lokasi harus diisi!'),
      pembicara: Yup.string().required('Pembicara harus diisi!'),
      nama_po_kegiatan: Yup.string().required('Nama PO Kegiatan harus diisi!'),
      biaya: Yup.number().min(0, 'Biaya tidak boleh negatif!'),
    }),
    onSubmit: () => {
      if (state.deskripsi !== '' && state.deskripsi !== undefined) {
        formData.append('deskripsi', state.deskripsi);
      }
      formData.append('nama_organisasi', state.nama_organisasi);
      formData.append('nama_po_kegiatan', state.nama_po_kegiatan);
      formData.append('jabatan', state.jabatan);
      formData.append('email', state.email);
      formData.append('no_telepon', state.no_telepon);
      formData.append('nama_kegiatan', state.nama_kegiatan);
      formData.append('jenis_kegiatan', state.jenis_kegiatan);
      formData.append('tanggal', state.tanggal);
      formData.append('pukul', state.pukul);
      formData.append('penyelenggara', state.penyelenggara);
      if (state.biaya !== -1 && state.biaya != null) {
        formData.append('biaya', state.biaya);
      }
      formData.append('sertifikat', state.sertifikat);
      if (state.link_regis !== 'https://' && state.link_regis !== undefined) {
        formData.append('link_regis', state.link_regis);
      }
      formData.append('lokasi', state.lokasi);
      formData.append('pembicara', state.pembicara);
      if (state.moderator !== '' && state.moderator !== undefined) {
        formData.append('moderator', state.moderator);
      }
      formData.append('proposal', proposal.files, proposal.files.name);
      axios.post(`${config.API_BASE_URL}api/pengajuan_kuliah_umum/`, formData, {
        headers: {
          'content-type': 'multipart/form-data',
          accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }).then(
        () => (
          props.history.push('/')
        ),
      );
    },
  });

  const handleSubmit1 = () => {
    let errorText = error;
    if (proposal) {
      const value = proposal.files;
      if (!SUPPORTED_FORMATS.includes(value.type)) {
        errorText = 'File harus berupa PDF!';
      } else if (value.size > FILESIZE) {
        errorText = 'Maksimum ukuran PDF 10 MB!';
      } else {
        errorText = '';
      }
    } else {
      errorText = 'Proposal harus ada!';
    }

    if (errorText === '') {
      formik.handleSubmit();
    } else {
      setError(errorText);
    }
    setModalShow(false);
  };

  const penjelasan = 'Silakan memasukkan data diri pengusul, data lengkap kegiatan, dan menekan tombol submit. Informasi mengenai diterima/ditolak akan kami kirimkan melalui alamat email yang Anda masukkan. Apabila Anda menemukan kesulitan, silakan menghubungi birpend di 08111927296/birpend.febui@ui.ac.id ';

  return (
    <Content>
      <h1 className="mb-4">Selamat Datang di Pengajuan Kegiatan KUM!</h1>
      <p className="mb-5">{ penjelasan }</p>
      <Card>
        <Card.Header>
          <p className="text-center">Data Pengusul Kegiatan</p>
        </Card.Header>
        <Card.Body>
          <Form>
            <Form.Group as={Row} controlId="formPlaintextNamaPengusul">
              <Form.Label row>
                Nama:
              </Form.Label>
              <Form.Control
                type="text"
                value={state.nama}
                readOnly
              />
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextNPMPengusul">
              <Form.Label row>
                NPM
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="npm"
                readOnly
                value={state.npm}
              />
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextProdiPengusul">
              <Form.Label row>
                Program Studi
              </Form.Label>
              <Form.Control
                type="text"
                value={state.prodi}
                readOnly
              />
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextNamaOrganisasi">
              <Form.Label row>
                Nama Organisasi
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="BEM FEB UI"
                name="nama_organisasi"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'nama_organisasi');
                }}
                value={state.nama_organisasi}
                data-testid="nama_organisasi"
              />
              {formik.errors.nama_organisasi && formik.touched.nama_organisasi && (
                <div data-testid="nama_organisasi_error" className="text-danger">{formik.errors.nama_organisasi}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextJabatanPengusul">
              <Form.Label row>
                Jabatan
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Kepala Departemen Kastrat"
                name="jabatan"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'jabatan');
                }}
                value={state.jabatan}
                data-testid="jabatan"
              />
              {formik.errors.jabatan && formik.touched.jabatan && (
                <div data-testid="jabatan_error" className="text-danger">{formik.errors.jabatan}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextEmailPengusul">
              <Form.Label row>
                E-mail
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="user@ui.ac.id"
                name="email"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'email');
                }}
                value={state.email}
                data-testid="email"
              />
              {formik.errors.email && formik.touched.email && (
                <div data-testid="email_error" className="text-danger">{formik.errors.email}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextNomorTeleponPengusul">
              <Form.Label row>
                Nomor Telepon
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="0812345677"
                name="no_telepon"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'no_telepon');
                }}
                value={state.no_telepon}
                data-testid="no_telepon"
              />
              {formik.errors.no_telepon && formik.touched.no_telepon && (
                <div data-testid="no_telepon_error" className="text-danger">{formik.errors.no_telepon}</div>
              )}
            </Form.Group>
          </Form>
        </Card.Body>

        <Card.Header>
          <p className="text-center">Data Kegiatan</p>
        </Card.Header>
        <Card.Body>
          <Form>
            <Form.Group as={Row} controlId="formPlaintextNamaKegiatan">
              <Form.Label row>
                Nama Kegiatan
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Kuliah Umum Ekonomi"
                name="nama_kegiatan"
                data-testid="nama_kegiatan"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'nama_kegiatan');
                }}
                value={state.nama_kegiatan}
              />
              {formik.errors.nama_kegiatan && formik.touched.nama_kegiatan && (
                <div data-testid="nama_kegiatan_error" className="text-danger">{formik.errors.nama_kegiatan}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextNamaKegiatan">
              <Form.Label row>
                Nama PO Kegiatan
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="nama_po_kegiatan"
                data-testid="nama_po_kegiatan"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'nama_po_kegiatan');
                }}
                value={state.nama_po_kegiatan}
              />
              {formik.errors.nama_po_kegiatan && formik.touched.nama_po_kegiatan && (
                <div data-testid="nama_po_kegiatan_error" className="text-danger">{formik.errors.nama_po_kegiatan}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextJenisKegiatan">
              <Form.Label row>
                Jenis Kegiatan
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                as="select"
                data-testid="jenis_kegiatan"
                name="jenis_kegiatan"
                className="jenis_kegiatan"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'jenis_kegiatan');
                }}
                value={state.jenis_kegiatan}
              >
                <option value="kuliah umum">kuliah umum</option>
                <option value="seminar ilmiah">seminar ilmiah</option>
              </Form.Control>
              {formik.errors.jenis_kegiatan && formik.touched.jenis_kegiatan && (
                <div className="text-danger">{formik.errors.jenis_kegiatan}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextHariTanggal">
              <Form.Label row>
                Hari/Tanggal
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="date"
                className="tanggal"
                name="tanggal"
                data-testid="tanggal"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'tanggal');
                }}
                value={state.tanggal}
              />
              {formik.errors.tanggal && formik.touched.tanggal && (
                <div className="text-danger">{formik.errors.tanggal}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextPukul">
              <Form.Label row>
                Pukul
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="time"
                data-testid="pukul"
                className="pukul"
                name="pukul"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'pukul');
                }}
                value={state.pukul}
              />
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextPenyelenggara">
              <Form.Label row>
                Penyelenggara
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                className="penyelenggara"
                name="penyelenggara"
                data-testid="penyelenggara"
                placeholder="BEM FEB UI"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'penyelenggara');
                }}
                value={state.penyelenggara}
              />
              {formik.errors.penyelenggara && formik.touched.penyelenggara && (
                <div className="text-danger">{formik.errors.penyelenggara}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextBiaya">
              <Form.Label row>
                Biaya
              </Form.Label>
              <Form.Control
                min="0"
                type="number"
                data-testid="biaya"
                className="biaya"
                name="biaya"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'biaya');
                }}
                value={state.biaya}
              />
              {formik.errors.biaya && formik.touched.biaya && (
                <div className="text-danger">{formik.errors.biaya}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextSertifikat">
              <Form.Label row>
                Sertifikat
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                as="select"
                data-testid="sertifikat"
                className="sertifikat"
                name="sertifikat"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'sertifikat');
                }}
                value={state.sertifikat}
              >
                <option value="Ya (E-Sertifikat Gratis)">Ya (E-Sertifikat Gratis)</option>
                <option value="Ya (E-Sertifikat Berbayar)">Ya (E-Sertifikat Berbayar)</option>
                <option value="Tidak Tersedia">Tidak Tersedia</option>
              </Form.Control>
              {formik.errors.sertifikat && formik.touched.sertifikat && (
                <div className="text-danger">{formik.errors.sertifikat}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextLinkRegistrasi">
              <Form.Label row>
                Link Registrasi
              </Form.Label>
              <Form.Control
                type="text"
                data-testid="link_regis"
                className="link_regis"
                name="link_regis"
                placeholder="s.id/daftarKUM"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'link_regis');
                }}
                value={state.link_regis}
              />
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextLokasi">
              <Form.Label row>
                Lokasi
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                data-testid="lokasi"
                className="lokasi"
                name="lokasi"
                placeholder="Balairung UI"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'lokasi');
                }}
                value={state.lokasi}
              />
              {formik.errors.lokasi && formik.touched.lokasi && (
                <div className="text-danger">{formik.errors.lokasi}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlainTextPembicara">
              <Form.Label row>
                Pembicara
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                data-testid="pembicara"
                className="pembicara"
                name="pembicara"
                placeholder="Fathurizki Luthfi Azzahra"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'pembicara');
                }}
                value={state.pembicara}
              />
              {formik.errors.pembicara && formik.touched.pembicara && (
                <div className="text-danger">{formik.errors.pembicara}</div>
              )}
            </Form.Group>

            <Form.Group as={Row} controlId="formPlainTextModerator">
              <Form.Label row>
                Moderator
              </Form.Label>
              <Form.Control
                type="text"
                data-testid="moderator"
                className="moderator"
                name="moderator"
                placeholder="Talitha Pradana"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'moderator');
                }}
                value={state.moderator}
              />
            </Form.Group>

            <Form.Group as={Row} controlId="forminputProposal">
              <Form.Label row>
                Upload Proposal
                <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  type="file"
                  className="proposal-uploader"
                  data-testid="proposal"
                  accept="application/pdf"
                  onChange={(e) => {
                    formik.handleChange(e);
                    handleFileChange(e);
                  }}
                />
              </Col>
            </Form.Group>
            {error !== '' && (
              <div data-testid="proposal_error" className="text-danger">{error}</div>
            )}

            <Form.Group as={Row} controlId="formPlainTextDeskripsi">
              <Form.Label row>
                Deskripsi
              </Form.Label>
              <Form.Control
                type="text"
                data-testid="deskripsi"
                className="deskripsi"
                name="deskripsi"
                placeholder="Deskripsi"
                onChange={(e) => {
                  formik.handleChange(e);
                  inputChange(e, 'deskripsi');
                }}
                value={state.deskripsi}
              />
            </Form.Group>

            <Col className="col-12 text-right buttonKanan">
              <Link to="/">
                <Button className="btnCancel btn-primary mr-2" variant="danger">Batal</Button>
              </Link>
              <Button className="btnKirim btn-primary" variant="success" onClick={() => setModalShow(true)}>Kirim</Button>
            </Col>
            <ModalKonfirmasi
              show={modalShow}
              onHide={() => setModalShow(false)}
              onSubmit={handleSubmit1}
            />

          </Form>
        </Card.Body>
      </Card>
    </Content>
  );
};

FormPengajuanKUM.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(FormPengajuanKUM);
